import React from "react"

function TimerEntry(props){
    var jamah = props.h+":"+props.m +" " +props.ap;
    var stTime;

    function format12HourTime(time24) {
        if (!time24) return "";
        const parts = time24.split(':');
        let hour = parseInt(parts[0], 10);
        const minute = parts[1];
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour ? hour : 12;
        return `${hour}:${minute} ${ampm}`;
    }

    switch(props.id) {
        case 1:
          stTime = format12HourTime(props.startTime.a);
          break;
        case 2:
          stTime = format12HourTime(props.startTime.b);
          break;
        case 3:
          stTime = format12HourTime(props.startTime.c);
          break;
        case 4:
          stTime = format12HourTime(props.startTime.d);
          break;
        case 5:
          stTime = format12HourTime(props.startTime.e);
          break;
        case 6:
          stTime = format12HourTime(props.startTime.f);
          break;
        default:
          console.log("error in TimeEntry switch stmet", props.id)
      }

    return(
        <tr>
            <td>{props.prayer}</td>
            <td><span>{stTime}</span></td>
            <td><span>{jamah}</span></td>
        </tr>
    );
}

export default TimerEntry